import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

export const MZContent = () => {

	return (
		<Container fluid="md" id="MZContent">
			<Row>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_01.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - One Elephant" />
					<h2>One Elephant</h2>
					<p>Elephant gives rides to the birds.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_02.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Two Polar Bears" />
					<h2>Two Polar Bears</h2>
					<p>Polar bears swimming in the water.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_03.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Three Seals" />
					<h2>Three Seals</h2>
					<p>Seals go to a party everyday.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_04.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Four Snakes" />
					<h2>Four Snakes</h2>
					<p>Snakes are hiding in the grasses.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_05.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Five Monkeys" />
					<h2>Five Monkeys</h2>
					<p>Monkeys swing from vines and each other.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_06.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Six Koala Bears" />
					<h2>Six Koala Bears</h2>
					<p>Koala bears sleeping in the trees.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_07.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Seven Frogs" />
					<h2>Seven Frogs</h2>
					<p>Frogs leaping on lily pads.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_08.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Eight Parrots" />
					<h2>Eight Parrots</h2>
					<p>Parrots fell from a rainbow. </p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_09.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Nine Penguins" />
					<h2>Nine Penguins</h2>
					<p>Penguins slip and slide on ice.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<Image fluid src={require('./images/mz_10.jpg')} className="aligncenter thumb" alt="Mabell's Zoo - Ten Fish" />
					<h2>Ten Fish</h2>
					<p>Tangs bring sunshine to the ocean.</p>
				</Col>
				<Col xs={12} md={6} lg={4} className="mz-view">
					<a href="http://studio6thave.com/mabellszoo-fun-pages/">
						<Image src={require('./images/mabellsFunPages.png')} width="140" height="119" alt="Mabell's Fun Pages" /></a>
					<p className="text-left">Activities featuring the Mabell's Zoo animals.</p>
					<ul>
						<li><a href="matchgame/">Mabell's Zoo Matching Game</a></li>
						<li>Happy Holidays! <a href="/holiday2013/">The Mabell's Zoo Penguins have gone caroling</a></li>
					</ul>
				</Col>
			</Row>
			<hr />
			<Row>
				<Col>
					<h2>Ma + Bell</h2>
					<p>Mabell's Zoo was created for and with my daughter, age 4. I was inspired by the numerous books we have read together. I am not a traditional author. I am an interactive media artist. Our book would need to include movement, music, and user interactions. It was also important that we could play together. Devices with multi-touch technology became our canvas, and with digital being the final delivery, I wanted the imagery to be so rich one would want to touch.</p>

					<p>My daughter was involved in all the creative aspects. She and I spent several afternoons crumpling and painting coffee filters. These creations became the beautiful textures used throughout Mabell's Zoo. She influenced color schemes and had opinions about which animals to include, how they looked, and their movement. She also insisted on how the title is pronounced, with a long A sound. Each view reminds me of childhood activities from blowing bubbles to tiddlywinks. We built a tent out of blankets which became our recording studio (or giggle house). Along with the story and numbers, I included extra fun sounds from those sessions.</p>

					<p>I have watched my daughter play and interact with the zoo. Each time, she explores a different view in depth and then gives me her own narrative. I provided an overall structure with the animals and sounds; yet, there is plenty of room for her own interpretation and story.</p>

					<p>Creating Mabell's Zoo with my daughter has been a wonderful experience. We are excited to share it with others and hope you will be inspired and add to your own memories. </p>
					<p>— Brenda Long, designer, developer, and mother</p>
				</Col>
			</Row>
			<hr />
			<Row>
				<Col>
					<h2>The Reviews</h2>
					<div>
						<blockquote>
							<div className="stars" title="5 Stars"></div>
							<p><span>"With vivid colors and easy to activate animations, <span>Mabell’s Zoo</span> not only provides a stimulating visual environment, but encourages counting 1-10."</span>
								<span>theiPhoneMom</span>, <span>5</span> stars. <a href="http://www.theiphonemom.com/Detailed_App_Review-detail/mabells-zoo-review/" target="_blank" rel="noreferrer">Read the full review</a>
							</p>
						</blockquote>
					</div>
					<blockquote>
						<div className="stars" title="5 Stars"></div>
						<p>"Spectacular is what first comes to mind with this interactive counting book app! From slipping, sliding penguins to ball balancing seals to monkeys that can be hooked together like the traditional &lsquo;barrel of monkeys&rsquo; game, this app is loads of fun. The musical touch is an awesome feature and keeps the kiddos engaged while exploring each page and making beautiful sound. I was really impressed with the exceptional graphics with such bright vivid colors. The app has a read to me feature, a repeat (looping) option, and a choice to view each page in number sequence (1-10) or mix them up and view each page randomly. Love Love Love Mabell&rsquo;s Zoo. I highly recommend it.", App Store User</p>
					</blockquote>

					<blockquote>
						<div className="stars" title="5 Stars"></div>
						<p>"Beautiful, engaging app. The artwork is gorgeous, totally interactive and fun to explore each area in the zoo. My 5 year old nephew really enjoyed being able to interact with the animals. Great app for teaching kids how to count and develop hand-eye coordination, probably as young as 6 months.", App Store User</p>
					</blockquote>

					<blockquote>
						<div className="stars" title="5 Stars"></div>
						<p>"My 3 1/2 year old granddaughter loves this. My granddaughter never tires of all the interesting things she can do with this beautiful app, but what I did not count on is how much I would fool around with it. As an educator, I can say this app is top notch. The tactile possibilities are endless, and the artwork feeds the eyes and imagination for any child of any age.", Google Play User</p>
					</blockquote>
				</Col>
			</Row>
			<hr />
			<Row>
				<Col xs={12} md={6} lg={3} className="mz-review">
					<p>Mabell's Zoo is included with <a href="http://awards.designforexperience.com/gallery/2013/experience-for-children/brenda-long-studio-6th-ave" target="_blank" rel="noreferrer">The International Design for Experience Awards</a> - Experience for Children. This award recognizes digital products for children that deliver excellent value, engagement, and ease of use for their users.</p>
					<p><a href="http://uxmag.com/articles/giving-kids-digital-experiences-they-can-really-use" target="_blank" rel="noreferrer">Giving Kids Digital Experiences They Can Really Use | UX Magazine</a></p>

				</Col>
				<Col xs={12} md={6} lg={3} className="mz-review">
					<a href="http://momswithapps.com/"><Image src={require("./images/KWI-Logo-Small-02.png")} width="118" height="214" alt="Moms with Apps Member" /></a>
					<p>Mabell's Zoo is a <a href="http://momswithapps.com/">MOMs with Apps</a> member, we follow the "Know what's inside" best practices for kids' apps</p>

				</Col>
				<Col xs={12} md={6} lg={3} className="mz-review">
					<a href="http://www.bookappalliance.com/member-book-apps/"><Image src={require("./images/BAAlogo125.jpg")} width="125" height="125" alt="Book App Alliance" /></a>
					<p>Member of the <a href="http://www.bookappalliance.com/member-book-apps/">Book App Alliance:</a> Industry Leading Authors Creating Interactive Books for Kids</p>
				</Col>
				<Col xs={12} md={6} lg={3} className="mz-review">
					<a href="http://youtu.be/AygjWZlzrec"><Image src={require("./images/youtube.jpg")} width="200" height="160" alt="App Time: Animals, YouTube Video" /></a>
					<p>Mabell's Zoo feature by <a href="http://youtu.be/AygjWZlzrec">App Time at Haggard Library</a>, Plano Public Library System</p>
				</Col>
			</Row>
			<hr />
		</Container>
	)
}